<template>
  <v-container fluid class="pa-3">
    <div class="text-center" v-if="!localVideoStream || !localAudioStream">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
        v-if="waiting"
      ></v-progress-circular>
      <div class="body-3">JOINボタンで会議に参加してください</div>
    </div>
    <RTCConnection
      type="student"
      :userId="userId"
      :localVideoStream="localVideoStream"
      :localAudioStream="localAudioStream"
      v-if="localVideoStream && localAudioStream"
      @onStateChanged="onStateChanged"
    />
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import { db } from "./utils-firebase";
import { media } from "./utils-stream";
import RTCConnection from "./RTCConnection.vue";

export default {
  components: { RTCConnection },

  data() {
    return {
      localVideoStream: null,
      localAudioStream: null,
      waiting: false
    };
  },

  computed: mapState(["roomId", "userId", "joined", "alias"]),

  watch: {
    joined(v) {
      console.log("StudentView.joined() v="+v)
      if (v) {
        this.waiting = true;
        this.openStream();
        db.addMember(this.roomId, this.userId, this.alias);
      } else {
        this.waiting = false;
        this.stopStream();
        console.log("a student exits")        
        db.delMember(this.roomId, this.userId);
      }
    }
  },

  methods: {
    openStream() {
      console.log("StudentView.openStream()")
      media.getScreenStream().then(s => {
        this.localVideoStream = s;
      }).catch((e)=>{
        console.log("StudentView.openStream():getScreenStream() e="+e)
      });

      media.getAudioStream().then(s => {
        this.localAudioStream = s;
      }).catch((e)=>{
        console.log("StudentView.openStream():getAudioStream() e="+e)
      });
    },

    stopStream() {
      media.closeStream(this.localVideoStream);
      media.closeStream(this.localAudioStream);
      this.localVideoStream = null;
      this.localAudioStream = null;
    },

    onStateChanged(state, userid) {
      console.log("StudentView.onStateChanged() state="+state+" userid="+userid)
      if (state == "disconnected") {
        console.log("disconnected, teacher has left. ");
        db.delMember(this.roomId, userid);
        this.stopStream();
        this.$store.commit("setJoined", false);
      }
    },    
  }
};
</script>
